const SEPARATOR = ';';
const NEEDS_QUOTING = /[";\r\n]/;

export interface BarcodeLabelRow {
  barcode: string;
  name: string;
  measureTypeName?: string | null;
}

export interface BarcodeLabelHeaders {
  barcode: string;
  name: string;
  measureType: string;
  asset: string;
}

// RFC 4180 quoting. Measure names are free text, so a `;` in one would otherwise
// shift every following column of that row into the wrong header.
function escapeCell(value: string): string {
  return NEEDS_QUOTING.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

export function buildBarcodeLabelCsv(rows: BarcodeLabelRow[], assetName: string, headers: BarcodeLabelHeaders): string {
  const lines = [
    [headers.barcode, headers.name, headers.measureType, headers.asset],
    ...rows.map(row => [row.barcode, row.name, row.measureTypeName ?? '', assetName]),
  ];
  return lines.map(cells => cells.map(escapeCell).join(SEPARATOR)).join('\n');
}
